// Conversión de unidades del Plan de Emergencias v2.
// 1 kcal = 4,1868 kJ (caloría internacional). Se calcula sin redondear; se redondea solo al mostrar.

export const KJ_POR_KCAL = 4.1868;
export const MJ_POR_KCAL = KJ_POR_KCAL / 1000;

export const kcalAMJ = (kcal: number): number => kcal * MJ_POR_KCAL;
export const mjAKcal = (mj: number): number => mj / MJ_POR_KCAL;
// Mcal/m² (unidad del factor "carga térmica" de MESERI en el plan de referencia).
export const mjAMcal = (mj: number): number => mjAKcal(mj) / 1000;

export const segundosAMinutos = (s: number): number => s / 60;

// Solo para mostrar: redondeo decimal sin errores de coma flotante en los .5.
export function redondear(valor: number, decimales: number): number {
  const f = Math.pow(10, decimales);
  return Math.round((valor + Number.EPSILON) * f) / f;
}

// Formato de Ecuador para la pantalla: coma decimal y punto de miles (es-EC). Ej.: 23646,4 → "23.646,4".
export function formatoEc(valor: number, decimales = 1): string {
  if (!Number.isFinite(valor)) return '—';
  const [entero, dec] = Math.abs(redondear(valor, decimales)).toFixed(decimales).split('.');
  const miles = entero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${valor < 0 && redondear(valor, decimales) !== 0 ? '-' : ''}${miles}${dec ? `,${dec}` : ''}`;
}

// Número para las notas y trazas visibles (PE-B1, 6a): coma decimal, punto de miles y solo los decimales que
// hacen falta (hasta maxDecimales). Ej.: 0,9 · 1,3 · 7,6 · 13.600 · 0,86. Es el formateador único de las notas.
export function numEc(valor: number, maxDecimales = 2): string {
  if (!Number.isFinite(valor)) return '—';
  const r = redondear(valor, maxDecimales);
  let d = 0;
  while (d < maxDecimales && Math.abs(redondear(r, d) - r) > 1e-9) d++;
  return formatoEc(r, d);
}

// Tiempo en segundos y en minutos y segundos (PE-A3c; evita el "0,30 segundos" del plan de referencia).
// Ej.: 18,1 → "18,1 s (0 min 18 s)"; 75,6 → "75,6 s (1 min 16 s)".
export function formatoTiempo(segundos: number): string {
  if (!Number.isFinite(segundos)) return '—';
  const total = Math.round(segundos);
  return `${formatoEc(segundos, 1)} s (${Math.floor(total / 60)} min ${total % 60} s)`;
}

// Lee un número escrito con coma decimal (también acepta punto). Sin separador de miles.
// Vacío → null; texto inválido → NaN.
export function leerDecimalEc(texto: string): number | null {
  const t = texto.trim().replace(/\s/g, '');
  if (t === '') return null;
  if (!/^-?\d*([.,]\d*)?$/.test(t) || t === '-' || t === ',' || t === '.') return NaN;
  return Number(t.replace(',', '.'));
}
